import { useState } from 'react';
import styled from 'styled-components';
import { Banner } from 'ui/banner';
import { BannerVariants } from 'ui/banner/types';
import { WarningFill16 } from 'ui/icons';
import { Popover, PopoverContent, PopoverTrigger } from 'ui/popover';
import { RouterLink2 } from 'ui/theme';
import { FieldDataType, FieldLockState } from '../types';
import { createFieldLockText } from '../utils';

type FieldLockNotificationProps = {
  fieldType?: FieldDataType;
  fieldLockState?: FieldLockState;
};

const StyledTrigger = styled(PopoverTrigger)`
  text-decoration: underline dotted;
`;

export const FIELD_LOCK_NOTIFICATION_TEXT = {
  linkText: 'Go to Settings',
  testId: 'project-settings-info-banner',
  settingsUrl: '/settings/dataSchemaManagement?contentSection=settings',
};

export const FieldLockNotification = ({
  fieldType,
  fieldLockState,
}: FieldLockNotificationProps) => {
  const [popoverOpen, togglePopoverOpen] = useState(false);
  const { linkText, settingsUrl, testId } = FIELD_LOCK_NOTIFICATION_TEXT;
  const fieldLockText = createFieldLockText(fieldType, fieldLockState);

  if (!fieldLockText) return null;

  return (
    <Banner Icon={<WarningFill16 />} isSubtle variant={BannerVariants.WARNING}>
      <Popover open={popoverOpen} onOpenChange={togglePopoverOpen}>
        <StyledTrigger data-test={testId}>{fieldLockText.label}</StyledTrigger>
        <PopoverContent
          side="right"
          LinkContent={<RouterLink2 to={settingsUrl}>{linkText}</RouterLink2>}
        >
          {fieldLockText.content}
        </PopoverContent>
      </Popover>
    </Banner>
  );
};
